import AuthorizationActivities from './AuthorizationActivities'
export default AuthorizationActivities
